.tooltip {
  font-size: var(--phx-fontSizeSmall, 0.75rem);
  color: var(--phx-tooltipColor, #fff);
  background-color: var(--phx-tooltipBackgroundColor, #c70360);
  padding: 3px 6px;
  border-radius: 6px;
  font-family: var(--phx-fontFamily, Lato, sans-serif);
}

.arrow {
  position: absolute;
  width: 5px;
  height: 5px;
}
.arrow:after {
  content: " ";
  position: absolute;
  top: -6px;
  left: 0;
  transform: rotate(45deg);
  width: 5px;
  height: 5px;
  background-color: var(--phx-tooltipBackgroundColor, #c70360);
}
.arrow--top, .arrow--top-start, .arrow--top-end {
  top: 25px;
}
.arrow--left {
  right: -3px;
}
.arrow--left:after {
  top: 0;
}
.arrow--right {
  left: -3px;
}
.arrow--right:after {
  top: 0;
}